import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { UntypedFormControl, ValidationErrors, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

import { AbstractInput } from '../abstract/input';

export const NUMBER_VALUE_EVENT_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => InputNumberEventsComponent),
	multi: true
};

export const NUMBER_VALUE_EVENT_VALIDATOR = {
	provide: NG_VALIDATORS,
	useExisting: forwardRef(() => InputNumberEventsComponent),
	multi: true,
};

@Component({
	selector: 'app-input-number-events',
	templateUrl: 'number-events.component.html',
	providers: [NUMBER_VALUE_EVENT_ACCESSOR, NUMBER_VALUE_EVENT_VALIDATOR]
})
export class InputNumberEventsComponent extends AbstractInput<number> {
	@Input()
	placeholder: string = '#';

	@Input()
	min: number | undefined = undefined;

	@Input()
	max: number | undefined = undefined;

	@Input()
	formatThousands: boolean = true;

	@Output() valueChange = new EventEmitter<boolean>();

	onValueChange(newValue: any) {
 
	  this.valueChange.emit(true);  
	}
	
	validate(control: UntypedFormControl): ValidationErrors | null {
		if (this.min && control.value < this.min) {
			return {
				min: this.min
			};
		}
		if (this.max && control.value > this.max) {
			return {
				max: this.max
			};
		}
		return null;
	}
}
